export const center = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
